import React from "react";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  Brush,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${"مبلغ"} : ${payload[0].value.toLocaleString()} ریال`}</p>
      </div>
    );
  }

  return null;
};

const Chart = ({ data }) => {
  const MinMax = data
    .filter(i => i.date !== 0)
    .reduce(
      (accumulator, currentValue) => {
        return [
          Math.min(currentValue.amount, accumulator[0]),
          Math.max(currentValue.amount, accumulator[1])
        ];
      },
      [Number.MAX_VALUE, Number.MIN_VALUE]
    );

  return (
    <div className="chartContainer">
      <ResponsiveContainer height={300} id="ChartId">
        {data.length > 1 ? (
          <AreaChart
            data={data}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="50%" stopColor="#fdd250" stopOpacity={0.6} />
                <stop offset="100%" stopColor="#3aeabb" stopOpacity={0.3} />
              </linearGradient>
            </defs>
            <XAxis dataKey="date" />
            <Brush
              dataKey="date"
              height={30}
              stroke={"#3aeabb"}
              travellerWidth={10}
              startIndex={0}
            />
            <YAxis tick={false} />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="linear"
              dataKey="amount"
              fillOpacity={1}
              fill="url(#colorUv)"
            />
          </AreaChart>
        ) : (
          <BarChart
            data={data}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="50%" stopColor="#fdd250" stopOpacity={0.6} />
                <stop offset="100%" stopColor="#3aeabb" stopOpacity={0.3} />
              </linearGradient>
            </defs>
            <XAxis dataKey="date" />
            <YAxis tick={false} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="amount" fill="#3aeabb" barSize={5} />
          </BarChart>
        )}
      </ResponsiveContainer>
      <div className="MinAndMax">
        <h4
          style={{ color: "red" }}
        >{`بیشترین مبلغ ${MinMax[1].toLocaleString()} ریال`}</h4>
        <h4
          style={{ color: "green" }}
        >{`کمترین مبلغ ${MinMax[0].toLocaleString()}  ریال`}</h4>
      </div>
    </div>
  );
};

export default Chart;
